import { Store } from "../uidispatcherapi/Store";
import FooterActions from "../actions/FooterActions";
const CHECKOUT = "checkout";
const LOGOUT = "logout";
const EX_LOGIN = "exlogin";
const NO_FOOTER_URLS = ["/backoffice", "/orderentry", "/order-entry", "/featureToggling", "/print"];

class FooterStoreImpl extends Store {
	_reducedFooterPathPrefix: string | null;
	_isReducedFooter: boolean;
	_IsNoFooter: boolean;

	constructor() {
		super();
		this._reducedFooterPathPrefix = null;
		this._isReducedFooter = false;
		this._IsNoFooter = false;
		this.listenTo(FooterActions.updateFooter, this.updatePageFooter);
	}

	updatePageFooter: (...args: Array<any>) => any = (): void => {
		const pathName = this.getReducedFooterPathPrefixes();

		if (this.isUrlNoFooter()) {
			this._isReducedFooter = false;
			this._reducedFooterPathPrefix = null;
			this._IsNoFooter = true;
			this.trigger();
		} else if (this._reducedFooterPathPrefix !== pathName && !this._isReducedFooter) {
			this._reducedFooterPathPrefix = pathName;
			this._isReducedFooter = true;
			this._IsNoFooter = false;
			this.trigger();
		} else if (this._isReducedFooter && !pathName) {
			this._isReducedFooter = false;
			this._reducedFooterPathPrefix = null;
			this._IsNoFooter = false;
			this.trigger();
		}
	};

	getReducedFooterPathPrefixes(): string | null {
		const currentPath = window.location.pathname;
		const footerPathPrefixes = [CHECKOUT, LOGOUT, EX_LOGIN];
		const pathName = currentPath
			.split("/")
			.filter(path => path !== "")
			.filter(path => footerPathPrefixes.includes(path));

		if (pathName && pathName.length) {
			return pathName[0];
		}

		return null;
	}

	isUrlNoFooter(): boolean {
		const url = window.location.href;
		return NO_FOOTER_URLS.some(part => url.includes(part));
	}

	getIsReducedFooter(): boolean {
		return this._isReducedFooter;
	}

	getIsNoFooter(): boolean {
		if (this.isUrlNoFooter()) {
			this._IsNoFooter = true;
		}

		return this._IsNoFooter;
	}
}

export const FooterStore = new FooterStoreImpl() as FooterStoreImpl;
